import en from './translations.en';
import fr from './translations.fr';

const translations = {
  en,
  fr,
};

export default translations;
